import { formatSiteDate, formatSiteTime, siteCalendarDay, type SiteDateFormat } from '@bms/common/utils';
import type { DeskFormat } from './deskResults';

/**
 * Times on the site's clock (the stays route names its zone), days as words
 * near today: "today 11:00", "tomorrow 08:00", otherwise the full site date and time.
 */
export function createDeskFormat(
  t: DeskFormat['t'],
  locale: string,
  timeZone: string | undefined,
  now: Date,
  format: SiteDateFormat = 'iso',
): DeskFormat {
  const options = { locale, timeZone, format };
  const today = siteCalendarDay(now, timeZone);

  const day = (iso: string) => {
    const at = new Date(iso);
    if (Number.isNaN(at.getTime())) return iso;
    const offset = siteCalendarDay(at, timeZone) - today;
    if (offset === 0) return t('search.day.today');
    if (offset === 1) return t('search.day.tomorrow');
    if (offset === -1) return t('search.day.yesterday');
    return formatSiteDate(at, options);
  };
  const time = (iso: string) => {
    const at = new Date(iso);
    return Number.isNaN(at.getTime()) ? iso : formatSiteTime(at, options);
  };
  return { t, day, time, when: (iso) => `${day(iso)} ${time(iso)}` };
}
